import { Outlet } from "react-router-dom";
import { AppLayout } from "./AppLayout";

export type Props = {
  title: string;
};

export function AuthLayout({ title }: Props) {
  return (
    <AppLayout
      className="min-h-[100dvh] flex flex-col bg-brand-50 text-brand-800 p-8 md:p-20"
      isWithFooter={false}
      title={title}
    >
      <Outlet />
    </AppLayout>
  );
}

export default AuthLayout;
